import { Service } from '../types';

interface ServicesProps {
  services: Service[];
}

function Services({ services }: ServicesProps) {
  return (
    <div id="fh5co-features" className="animate-box">
      <div className="container">
        <div className="services-padding">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
              <h2>My Services</h2>
            </div>
          </div>
          <div className="row">
            {services.slice(0, 3).map((service) => (
              <div key={service.title} className="col-md-4 text-center">
                <div className="feature-left">
                  <span className="icon">
                    <i className={service.icon}></i>
                  </span>
                  <div className="feature-copy">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="row">
            {services.slice(3).map((service) => (
              <div key={service.title} className="col-md-4 text-center">
                <div className="feature-left">
                  <span className="icon">
                    <i className={service.icon}></i>
                  </span>
                  <div className="feature-copy">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
